import { renderImage } from "../../../../utils/helper.jsx";
import React, { useEffect, useState } from "react";
import style from "../index.module.css";
import Modal from "react-bootstrap/Modal";
function Attachment({ docs }) {
  const fileExt = docs.split(".").pop();
  const [isOpen, setIsOpen] = useState(false);
  //if fileExt is image render in img, but if not image just create a link to download
  return (
    <div>
      <Modal show={isOpen} size={"lg"} onHide={() => setIsOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Attachment - View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            style={{
              border: "1px solid #c1c1c1",
              borderRadius: "10px",
              width: "100%",
              cursor: "pointer",
            }}
            src={renderImage(`/machine/attachment/${docs}`)}
            alt=""
          />
        </Modal.Body>
      </Modal>
      {fileExt === "png" || fileExt === "jpg" || fileExt === "jpeg" ? (
        <img
          onClick={() => setIsOpen(true)}
          style={{
            border: "1px solid #c1c1c1",
            borderRadius: "10px",
            width: "200px",
            cursor: "pointer",
          }}
          src={renderImage(`/machine/attachment/${docs}`)}
          alt=""
        />
      ) : (
        <a
          href={renderImage(`/machine/attachment/${docs}`)}
          target={"_blank"}
          download
        >
          <div style={{ display: "flex" }}>
            <div className={style.attachment}>
              <div style={{ paddingTop: "3px" }}>
                <i className="fa fa-paperclip"></i>
              </div>
              <div style={{ paddingTop: "3px" }}>Attachment</div>
            </div>
          </div>
        </a>
      )}
    </div>
  );
}

export default Attachment;
